export const FULL_NAME = 'fullName'
export const RELATIONSHIP_TO_DECEASED = 'relationshipToDeceased'
export const NOTES = 'notes'
export const IS_ADOPTED = 'isAdopted'
export const ADOPTION_TYPE = 'adoptionType'
export const HAS_ADOPTION_CERTIFICATE = 'hasAdoptionCertificate'
export const HAS_ADOPTED_RELATIVES = 'hasAdoptedRelatives'
